import { useState } from "react";

function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
    setSuccess("");
  };

  // ✅ Validation
  const validate = () => {
    if (!form.name || !form.email || !form.message) {
      return "Please fill all fields";
    }

    const emailRegex = /\S+@\S+\.\S+/;
    if (!emailRegex.test(form.email)) {
      return "Enter a valid email";
    }

    return "";
  };

  // ✅ WhatsApp Send
  const sendWhatsApp = () => {
    const text = encodeURIComponent(
      `Name: ${form.name}\nEmail: ${form.email}\nMessage: ${form.message}`
    );

    window.open(`https://wa.me/918970745451?text=${text}`, "_blank");
    setSuccess("Opening WhatsApp...");
  };

  // ✅ Email Send
  const sendEmail = () => {
    const subject = encodeURIComponent("Contact from Website");
    const body = encodeURIComponent(
      `Name: ${form.name}\nEmail: ${form.email}\nMessage: ${form.message}`
    );

    window.location.href = `mailto:capitolmysuru@gmail.com?subject=${subject}&body=${body}`;
    setSuccess("Opening Email...");
  };

  const handleSubmit = (type) => {
    const validationError = validate();

    if (validationError) {
      setError(validationError);
      return;
    }

    if (type === "whatsapp") {
      sendWhatsApp();
    } else {
      sendEmail();
    }
  };

  return (
    <section className="py-16 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">

        {/* Title */}
        <h1 className="text-4xl font-bold text-blue-900 mb-12 text-center">
          Contact Us
        </h1>

        <div className="grid md:grid-cols-2 gap-10">

          {/* LEFT - Info */}
          <div className="bg-white p-8 rounded-2xl shadow">

            <h2 className="text-2xl font-bold text-yellow-500 mb-4">
              Mysuru Branch
            </h2>

            <p className="text-gray-700 mb-4">
              <strong>Capitol Public School</strong><br />
              2899, Pampapathi Main Road,<br />
              Saraswathipuram, Mysuru – 570009
            </p>

            <p className="mb-2">
              📞 <a href="tel:8970745451" className="hover:underline">8970745451</a>
            </p>

            <p className="mb-2">
              📞 <a href="tel:9740903333" className="hover:underline">9740903333</a>
            </p>

            <p className="mb-4">
              ✉ <a href="mailto:capitolmysuru@gmail.com" className="hover:underline">
                capitolmysuru@gmail.com
              </a>
            </p>

            <a
              href="https://wa.me/918970745451"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mt-4 bg-green-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-green-600 transition"
            >
              Chat on WhatsApp
            </a>

          </div>

          {/* RIGHT - Form */}
          <div className="bg-white p-8 rounded-2xl shadow">

            <h2 className="text-2xl font-bold text-yellow-500 mb-6">
              Send Message
            </h2>

            <div className="space-y-4">

              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={form.name}
                onChange={handleChange}
                className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-900"
              />

              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={form.email}
                onChange={handleChange}
                className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-900"
              />

              <textarea
                name="message"
                placeholder="Your Message"
                rows="5"
                value={form.message}
                onChange={handleChange}
                className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-900"
              />

              {/* Error */}
              {error && (
                <p className="text-red-600 text-sm">{error}</p>
              )}

              {/* Success */}
              {success && (
                <p className="text-green-600 text-sm">{success}</p>
              )}

              {/* Buttons */}
              <div className="flex flex-col gap-3">

                <button
                  onClick={() => handleSubmit("whatsapp")}
                  className="w-full bg-green-500 text-white py-3 rounded-lg font-semibold hover:bg-green-600"
                >
                  Send via WhatsApp
                </button>

                <button
                  onClick={() => handleSubmit("email")}
                  className="w-full bg-yellow-400 text-blue-900 py-3 rounded-lg font-bold hover:bg-yellow-300"
                >
                  Send via Email
                </button>

              </div>

            </div>
          </div>

        </div>

        {/* Map */}
        <div className="mt-16 rounded-2xl overflow-hidden shadow-lg">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3898.223274926649!2d76.63431607506521!3d12.300745387956391!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3baf7aa500000001%3A0x523473308ce1f3b9!2sCAPITOL%20PUBLIC%20SCHOOL!5e0!3m2!1sen!2sin!4v1777969345559!5m2!1sen!2sin"
            width="100%"
            height="400"
            style={{ border: 0 }}
            loading="lazy"
            title="School Location"
          ></iframe>
        </div>

      </div>
    </section>
  );
}

export default Contact;